import { ActionGroup } from '@aibees/shared/features/action-group';
import { styled } from '@mui/material/styles';

export const Wrapper = styled(ActionGroup)`
  top: -17px;
`;
